import React from "react";
import { FaTimes } from "react-icons/fa";

interface ConfirmationModalProps {
  show: boolean;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  icon?: React.ReactNode;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  title,
  message,
  confirmText = "نعم",
  cancelText = "لا",
  onConfirm,
  onCancel,
  icon,
}) => {
  if (!show) return null;

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
      <div className='bg-white rounded-xl p-6 w-[90%] max-w-md text-center relative space-y-6'>
        {/* Close button */}
        <button
          className='absolute top-3 right-3 text-gray-500 hover:text-black text-xl'
          onClick={onCancel}
        >
          <FaTimes />
        </button>

        {/* Optional Title */}
        {title && <h3 className='text-xl font-bold text-gray-800'>{title}</h3>}

        {/* Icon */}
        {icon && <div className='flex justify-center'>{icon}</div>}

        {/* Message */}
        <div className='text-right text-gray-800 font-medium whitespace-pre-line leading-relaxed'>
          {message}
        </div>

        {/* Buttons */}
        <div className='flex justify-center gap-4'>
          <button
            type='button'
            className='px-8 py-3 border border-red-600 text-red-600 rounded-lg text-lg font-bold'
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            type='button'
            className='px-8 py-3 bg-red-700 text-white rounded-lg text-lg font-bold'
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
